import React from 'react';
import { WaitingMarker } from '../../icons';

/**
 * Timer-gated mission — predecessor done, clock still running.
 */
const WaitingMissionItem = ({ task, onGoToTask, onMouseEnter, onMouseLeave }) => (
  <div
    className="flowchart-hud__mission-item flowchart-hud__mission-item--waiting"
    onClick={() => onGoToTask?.(task.id)}
    title={task.blockedReason || 'Available soon'}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <span className="flowchart-hud__mission-marker">
      <WaitingMarker size={16} className="flowchart-hud__waiting-icon--small" />
    </span>
    <span className="flowchart-hud__mission-name">
      {task.name}
      {task.blockedReason ? (
        <span className="flowchart-hud__mission-wait"> · {task.blockedReason}</span>
      ) : null}
    </span>
  </div>
);

export default WaitingMissionItem;
